var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d8232a;}.b{opacity:0.567;fill:url(#a);}.c{fill:#ed9f2d;}.d{clip-path:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3dadf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,4.243A5.489,5.489,0,0,1,2,0,5.489,5.489,0,0,1,4,4.243,5.489,5.489,0,0,1,2,8.485,5.489,5.489,0,0,1,0,4.243Z",
    transform: "translate(0 0)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 32,
    height: 21,
    rx: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.5,
    cy: 5.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.5,11A5.508,5.508,0,0,1,0,9.743,5.485,5.485,0,0,0,2,5.5,5.486,5.486,0,0,0,0,1.257,5.5,5.5,0,1,1,3.5,11Z",
    transform: "translate(9 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 1.258)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,4.243A5.489,5.489,0,0,1,2,0,5.489,5.489,0,0,1,4,4.243,5.489,5.489,0,0,1,2,8.485,5.489,5.489,0,0,1,0,4.243Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,8.5V8H5v.5Zm0-1V7H5v.5Zm0-1V6H5v.5Zm0-1V5H5v.5Zm0-1V4H5v.5Zm0-1V3H5v.5Zm0-1V2H5v.5Zm0-1V1H5v.5Zm0-1V0H5V.5Z",
    transform: "translate(-0.5 0.242)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMastercard);
export default __webpack_public_path__ + "static/media/icn-mastercard.8eeea7fbb92d83dc3b5213c6468a890d.svg";
export { ForwardRef as ReactComponent };